import React from 'react';
import { Container } from 'library';

import CMSContent from '../../../common/CMSContent/CMSContent';
import FormstackForm from '../../../forms/FormstackForm/FormstackForm';

import './FancyForm.scss';

const FancyForm = ({ formHeader, blockContent, form = {} }) => {
  const { formUrl, formWidth, formHeight } = form;

  return (
    <div className="FancyForm">
      <Container row justify="center">
        <Container grid={11}>
          <div className="FancyFormWrapper">
            {blockContent && (
              <div className="FancyFormSidePanel">
                <CMSContent content={blockContent} />
              </div>
            )}
            <div className="FancyFormForm">
              <div className="FancyFormFormInner">
                {formHeader && <h2>{formHeader}</h2>}
                <FormstackForm formKey={formUrl} width={formWidth || '100%'} height={formHeight} scroll="yes" />
              </div>
            </div>
          </div>
        </Container>
      </Container>
    </div>
  );
};

export default FancyForm;
